
const Layout = () => import('./components/ui/layout')

const ForgotPassword = () => import('./pages/ForgotPassword')
const ResetPassword = () => import('./pages/ResetPassword')
const SignIn = () => import('./pages/SignIn')
const SignUp = () => import('./pages/SignUp')

export default [
  {
    path: '/auth',
    component: Layout,
    children: [
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: {
          title: 'Forgot Password',
        },
      },
      {
        path: 'reset-password/:id',
        name: 'ResetPassword',
        component: ResetPassword,
        props: ({ params, query }) => ({ resetId: params.id, resetToken: query.token }),
        meta: {
          title: 'Reset Password',
        },
      },
      {
        path: 'signin',
        name: 'SignIn',
        component: SignIn,
        meta: {
          title: 'Sign In',
        },
      },
      {
        path: 'signup',
        name: 'SignUp',
        component: SignUp,
        meta: {
          title: 'Sign Up',
        },
      },
    ],
  },
]
